/**
 * @description: Here define the initial state of the device structure component
 * @property {Array} deviceData - The array of the devices data which belongs to the organization.
 * @property {String} searchString - The search string which user input to search the device.
 * @property {Array} searchResult - The array of the search result based on the search string.
 * @property {Boolean} isLoading
 * @property {Boolean} isSuccess
 * @property {Boolean} isError
 * @property {String} errorMessage
 */
export const deviceStructureState = {
	deviceData: [],
	searchString: "",
	searchResult: [],
	isLoading: false,
	isSuccess: false,
	isError: false,
	errorMessage: ""
}
